import axiosClient, { cache } from "../../../network";

export default class lobbyService {
  static getProviders(params) {
    return axiosClient
      .get("/casino/getAllProvider", {
        params
      })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        if (error.data) {
          return { error: error.data };
        }
        return {
          error
        };
      });
  }

  static getSubCategory() {
    return axiosClient
      .get("/casino/getAllSubCategory")
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        if (error.data) {
          return { error: error.data };
        }
        return {
          error
        };
      });
  }
  static getAllGames(params) {
    return axiosClient
      .get("casino/getAllGames", {
        params
      })
      .then(({ data }) => {
        if (data?.data?.games?.length > 0) {
          return data;
        } else {
          return axiosClient
            .get("casino/getAllGames", {
              params,
              clearCacheEntry: true
            })
            .then((response) => {
              return response?.data;
            })
            .catch((error) => {
              if (error.data) {
                return { error: error.data };
              }
              return {
                error
              };
            });
        }
      })
      .catch((error) => {
        if (error.data) {
          return { error: error.data };
        }
        return {
          error
        };
      });
  }

  static getGameLink(payload) {
    return axiosClient
      .post("/launchGame", payload)
      .then(({ data, status }) => {
        return { data, status };
      })
      .catch((error) => {
        if (error.data) {
          return { error: error.data };
        }
        return {
          error
        };
      });
  }

  static getUserBonuses(params) {
    return axiosClient
      .get("/bonus/getBonusDetail", {
        params
      })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        if (error.data) {
          return { error: error.data };
        }
        return {
          error
        };
      });
  }

  static getAuthUserBonuses(params) {
    return axiosClient
      .get("/bonus/getUserBonus", {
        params
      })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        if (error.data) {
          return { error: error.data };
        }
        return {
          error
        };
      });
  }

  static activateBonus(payload) {
    return axiosClient
      .post("/bonus/addOrUpdateBonus", {
        ...payload
      })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        if (error.data) {
          return { error: error.data };
        }
        return {
          error
        };
      });
  }

  static getAllSearchedGames(params) {
    return axiosClient
      .get("/casino/getAllFilteredGames", {
        params
      })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        if (error.data) {
          return { error: error.data };
        }
        return {
          error
        };
      });
  }

  static getBannersData(payload) {
    return axiosClient
      .post("user/getBanner", payload)
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        if (error.data) {
          return { error: error.data };
        }
        return {
          error
        };
      });
  }

  static getfavorites(params) {
    return axiosClient
      .get("casino/getAllFavoriteGames", {
        params,
        clearCacheEntry: true
      })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        if (error.data) {
          return { error: error.data };
        }
        return {
          error
        };
      });
  }

  static addRemoveFavorites(payload) {
    return axiosClient
      .post("user/makeCasinoGameFav", {
        ...payload
      })
      .then(({ data }) => {
        return cache.store.clear().then(() => {
          return data;
        });
      })
      .catch((error) => {
        if (error.data) {
          return { error: error.data };
        }
        return {
          error
        };
      });
  }

  static getAllTopGames(params) {
    return axiosClient
      .get("/casino/getAllTopGames", {
        params
      })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        if (error.data) {
          return { error: error.data };
        }
        return {
          error
        };
      });
  }

  static getSuggestedGames(params) {
    return axiosClient
      .get("/casino/getSuggestedGames", {
        params
      })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        if (error.data) {
          return { error: error.data };
        }
        return {
          error
        };
      });
  }
}
